import React, {Component} from 'react';
import {connect} from 'react-redux';
import Stack from './components/stack';
import Action from 'components/organisms/random-team-stacking/actions';

class RandomTeamStacking extends Component {
    onClick(use) {
        this.props.dispatch(Action.do('useStacking', !use));
    }

    render() {
        let {sportConfig, stacking} = this.props;

        if (!sportConfig.isReady()) {
            return false;
        }

        return (
            <div className={`advanced-filter${stacking.isEnabled() ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Disable TEAM STACKS
                    </button>
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="advanced-opener"
                    >
                        <i className="fa fa-cog"></i>Enable TEAM STACKS
                    </button>
                </div>

                <Stack />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, randomTeamStacking} = state;
    return {
        sportConfig,
        stacking: randomTeamStacking,
    };
}

export default connect(mapStatesToProps)(RandomTeamStacking);
